import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "aiModePickerContainer"
};
const _hoisted_2 = {
  class: "titleText"
};
const _hoisted_3 = {
  class: "subtitleText"
};
const _hoisted_4 = {
  class: "noteText"
};
const _hoisted_5 = {
  class: "modeCards"
};
const _hoisted_6 = {
  key: 0,
  class: "modeCardCheck"
};
const _hoisted_7 = {
  class: "modeCardTitle"
};
const _hoisted_8 = {
  class: "modeCardTagline"
};
const _hoisted_9 = {
  class: "modeCardDesc"
};
const _hoisted_10 = {
  class: "modeCardBestFor"
};
const _hoisted_11 = {
  class: "bestForHeader"
};
const _hoisted_12 = {
  class: "bestForText"
};
const _hoisted_13 = {
  key: 0,
  class: "modeCardCheck"
};
const _hoisted_14 = {
  class: "modeCardTitle"
};
const _hoisted_15 = {
  class: "modeCardTagline"
};
const _hoisted_16 = {
  class: "modeCardDesc"
};
const _hoisted_17 = {
  class: "modeCardBestFor"
};
const _hoisted_18 = {
  class: "bestForHeader"
};
const _hoisted_19 = {
  class: "bestForText"
};
const _hoisted_20 = ["title"];
const _hoisted_21 = {
  key: 0,
  class: "modeCardCheck"
};
const _hoisted_22 = {
  class: "modeCardTitle"
};
const _hoisted_23 = {
  class: "modeCardTagline"
};
const _hoisted_24 = {
  class: "modeCardDesc"
};
const _hoisted_25 = {
  class: "modeCardBestFor"
};
const _hoisted_26 = {
  class: "bestForHeader"
};
const _hoisted_27 = {
  class: "bestForText"
};
const _hoisted_28 = {
  key: 0,
  class: "modeCardCheck"
};
const _hoisted_29 = {
  class: "modeCardTitle"
};
const _hoisted_30 = {
  class: "modeCardTagline"
};
const _hoisted_31 = {
  class: "modeCardDesc"
};
const _hoisted_32 = {
  class: "modeCardBestFor"
};
const _hoisted_33 = {
  class: "bestForHeader"
};
const _hoisted_34 = {
  class: "bestForText"
};
const _hoisted_35 = {
  key: 0,
  class: "modeSubScreen modeComparisonSubScreen"
};
const _hoisted_36 = {
  class: "comparisonIntro"
};
const _hoisted_37 = {
  class: "comparisonPickers"
};
const _hoisted_38 = {
  class: "comparisonLabel"
};
const _hoisted_39 = {
  class: "comparisonLabel"
};
const _hoisted_40 = ["title"];
const _hoisted_41 = {
  class: "comparisonHighlightBox"
};
const _hoisted_42 = {
  class: "comparisonHighlightTitle"
};
const _hoisted_43 = {
  class: "comparisonHighlightItems"
};
const _hoisted_44 = {
  class: "comparisonHighlightItem"
};
const _hoisted_45 = {
  class: "comparisonHighlightItem"
};
const _hoisted_46 = {
  class: "comparisonHighlightItem"
};
const _hoisted_47 = {
  class: "comparisonHighlightItem"
};
const _hoisted_48 = {
  class: "bottomLineButton"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_icon = _resolveComponent("icon");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_standard_button = _resolveComponent("standard-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.title')), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.subtitle')), 1), _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.note')), 1), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: _normalizeClass(["modeCard", {
      active: _ctx.mode === 'ALL_CONTENT'
    }]),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.setMode('ALL_CONTENT'))
  }, [_ctx.mode === 'ALL_CONTENT' ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createVNode(_component_icon, {
    icon: "check"
  })])) : _createCommentVNode("", true), _cache[7] || (_cache[7] = _createElementVNode("div", {
    class: "modeCardIconWrap"
  }, [_createElementVNode("span", {
    class: "modeCardEmoji"
  }, "🌐")], -1)), _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.allContent.title')), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.allContent.tagline')), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.allContent.description')), 1), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_icon, {
    icon: "target"
  }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.bestForLabel')), 1)]), _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.allContent.bestFor')), 1)])], 2), _createElementVNode("div", {
    class: _normalizeClass(["modeCard", {
      active: _ctx.mode === 'SYNTHESIS'
    }]),
    onClick: _cache[1] || (_cache[1] = $event => _ctx.setMode('SYNTHESIS'))
  }, [_ctx.mode === 'SYNTHESIS' ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_icon, {
    icon: "check"
  })])) : _createCommentVNode("", true), _cache[8] || (_cache[8] = _createElementVNode("div", {
    class: "modeCardIconWrap"
  }, [_createElementVNode("span", {
    class: "modeCardEmoji"
  }, "📝")], -1)), _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.synthesis.title')), 1), _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.synthesis.tagline')), 1), _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.synthesis.description')), 1), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_icon, {
    icon: "clock-outline"
  }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.bestForLabel')), 1)]), _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.synthesis.bestFor')), 1)])], 2), _createElementVNode("div", {
    class: _normalizeClass(["modeCard", {
      active: _ctx.mode === 'COMPARISON',
      disabled: !_ctx.canCompare
    }]),
    title: !_ctx.canCompare ? _ctx.$t('aiSpeachGenerator.roleBased.modes.comparison.disabledTooltip') : '',
    onClick: _cache[2] || (_cache[2] = $event => _ctx.canCompare && _ctx.setMode('COMPARISON'))
  }, [_ctx.mode === 'COMPARISON' ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_icon, {
    icon: "check"
  })])) : _createCommentVNode("", true), _cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "modeCardIconWrap"
  }, [_createElementVNode("span", {
    class: "modeCardEmoji"
  }, "🔄")], -1)), _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.comparison.title')), 1), _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.comparison.tagline')), 1), _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.comparison.description')), 1), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createVNode(_component_icon, {
    icon: "scale-balance"
  }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.bestForLabel')), 1)]), _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.comparison.bestFor')), 1)])], 10, _hoisted_20), _createElementVNode("div", {
    class: _normalizeClass(["modeCard", {
      active: _ctx.mode === 'ROLE'
    }]),
    onClick: _cache[3] || (_cache[3] = $event => _ctx.setMode('ROLE'))
  }, [_ctx.mode === 'ROLE' ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(_component_icon, {
    icon: "check"
  })])) : _createCommentVNode("", true), _cache[10] || (_cache[10] = _createElementVNode("div", {
    class: "modeCardIconWrap"
  }, [_createElementVNode("span", {
    class: "modeCardEmoji"
  }, "🎯")], -1)), _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.role.title')), 1), _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.role.tagline')), 1), _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.role.description')), 1), _createElementVNode("div", _hoisted_32, [_createElementVNode("div", _hoisted_33, [_createVNode(_component_icon, {
    icon: "account-outline"
  }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.bestForLabel')), 1)]), _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.role.bestFor')), 1)])], 2)]), _ctx.mode === 'COMPARISON' ? (_openBlock(), _createElementBlock("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.comparison.intro')), 1), _createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.comparison.oldVersion')), 1), _cache[11] || (_cache[11] = _createElementVNode("div", {
    class: "comparisonLabelSpacer"
  }, null, -1)), _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.comparison.newVersion')), 1), _createVNode(_component_el_select, {
    modelValue: _ctx.oldDocumentJobID,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.oldDocumentJobID = $event),
    size: "large",
    class: "comparisonSelect"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aiFiles, f => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: 'old-' + f.jobID,
        label: f.name,
        value: f.jobID,
        disabled: f.jobID === _ctx.newDocumentJobID
      }, null, 8, ["label", "value", "disabled"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"]), _createElementVNode("div", {
    class: "comparisonArrow",
    onClick: _cache[5] || (_cache[5] =
    //@ts-ignore
    (...args) => _ctx.swapVersions && _ctx.swapVersions(...args)),
    title: _ctx.$t('aiSpeachGenerator.roleBased.modes.comparison.swapTooltip')
  }, [_createVNode(_component_icon, {
    icon: "swap-horizontal",
    size: "large"
  })], 8, _hoisted_40), _createVNode(_component_el_select, {
    modelValue: _ctx.newDocumentJobID,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _ctx.newDocumentJobID = $event),
    size: "large",
    class: "comparisonSelect"
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.aiFiles, f => {
      return _openBlock(), _createBlock(_component_el_option, {
        key: 'new-' + f.jobID,
        label: f.name,
        value: f.jobID,
        disabled: f.jobID === _ctx.oldDocumentJobID
      }, null, 8, ["label", "value", "disabled"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.comparison.willHighlightTitle')), 1), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createVNode(_component_icon, {
    icon: "check-circle-outline",
    color: "success"
  }), _createTextVNode(" " + _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.comparison.highlight1')), 1)]), _createElementVNode("div", _hoisted_45, [_createVNode(_component_icon, {
    icon: "check-circle-outline",
    color: "success"
  }), _createTextVNode(" " + _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.comparison.highlight2')), 1)]), _createElementVNode("div", _hoisted_46, [_createVNode(_component_icon, {
    icon: "check-circle-outline",
    color: "success"
  }), _createTextVNode(" " + _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.comparison.highlight3')), 1)]), _createElementVNode("div", _hoisted_47, [_createVNode(_component_icon, {
    icon: "check-circle-outline",
    color: "success"
  }), _createTextVNode(" " + _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.comparison.highlight4')), 1)])])])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_48, [_createVNode(_component_standard_button, {
    outlined: true,
    onAction: _ctx.onBack
  }, {
    default: _withCtx(() => [_createVNode(_component_icon, {
      icon: "arrow-left"
    }), _createTextVNode(" " + _toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.back')), 1)]),
    _: 1
  }, 8, ["onAction"]), _createVNode(_component_standard_button, {
    disabled: !_ctx.canValidate,
    onAction: _ctx.onValidate
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('aiSpeachGenerator.roleBased.modes.continueButton')) + " ", 1), _createVNode(_component_icon, {
      icon: "arrow-right"
    })]),
    _: 1
  }, 8, ["disabled", "onAction"])])]);
}